import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "../link";

const Wrapper = styled(Link)`
  width: 100%;
  max-width: 7em;
  display: block;
  margin: 0 auto;
  height: auto;
`;

const Butterfly: React.FC<Props> = ({ animate, width, altText }) => {
  const colours = ["#c2b59c", "#019b99", "#00afbe", "#e94600", "#dec346"];
  const tips = ["#1e406d", "#0392ae"];
  const coloursRan = colours.sort(() => Math.random() - 0.5);
  const tipsRan = tips.sort(() => Math.random() - 0.5);
  if (animate) {
    return (
      <Wrapper to="/" aria-label="katanya" alt={altText || "butterfly"}>
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1080 1080"
          width={width || "100%"}
          whileHover={{ scale: 0.8 }}
          style={{ originX: "50%", originY: "50%" }}
          whileTap={{ rotate: -10 }}
        >
          <motion.polygon
            fill="#019b99"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: tipsRan.pop() }}
            transition={{ duration: Math.random() }}
            points="448.42 298.52 149.4 0 149.4 597.03 448.42 298.52"
          />
          <motion.rect
            fill="#e94600"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: coloursRan.pop() }}
            transition={{ duration: Math.random() * 2 }}
            x="192.25"
            y="491.7"
            width="212.13"
            height="211.23"
            transform="translate(-334.57 385.63) rotate(-45)"
          />
          <motion.polygon
            fill="#0392ae"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: coloursRan.pop() }}
            transition={{ duration: Math.random() * 2 }}
            points="447.71 806.68 658.26 1016.98 658.26 596.38 447.71 806.68"
          />
          <motion.polygon
            fill="#dec346"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: coloursRan.pop() }}
            transition={{ duration: Math.random() * 2 }}
            points="298.51 447.63 448.42 596.74 448.42 298.52 298.51 447.63"
          />
          <motion.polygon
            fill="#adbb40"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: coloursRan.pop() }}
            transition={{ duration: Math.random() * 2 }}
            points="149.26 597.45 0 746.71 298.52 746.71 149.26 597.45"
          />
          <motion.polyline
            fill="#c2b59c"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: coloursRan.pop() }}
            transition={{ duration: Math.random() * 2 }}
            points="447.99 596.21 447.71 806.93 658.59 596.05 658.48 386.05"
          />
          <motion.polygon
            fill="#00afbe"
            initial={{ fill: "rgba(255, 255, 255, 0.2)" }}
            animate={{ fill: tipsRan.pop() }}
            transition={{ duration: Math.random() }}
            points="658.42 385.74 658.42 807.9 1080.59 385.74 658.42 385.74"
          />
        </motion.svg>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper to="/" aria-label="home" alt={altText || "Butterfly"}>
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1080 1080"
          width={width || "100%"}
          whileHover={{ scale: 0.9 }}
          style={{ originX: "50%", originY: "50%" }}
          whileTap={{ rotate: -20 }}
        >
          <polygon
            style={{ fill: tipsRan.pop() }}
            points="448.42 298.52 149.4 0 149.4 597.03 448.42 298.52"
          />
          <rect
            fill={coloursRan.pop()}
            x="192.25"
            y="491.7"
            width="212.13"
            height="211.23"
            transform="translate(-334.57 385.63) rotate(-45)"
          />
          <polygon
            fill={coloursRan.pop()}
            points="447.71 806.68 658.26 1016.98 658.26 596.38 447.71 806.68"
          />
          <polygon
            fill={coloursRan.pop()}
            points="298.51 447.63 448.42 596.74 448.42 298.52 298.51 447.63"
          />
          <polygon
            fill={coloursRan.pop()}
            points="149.26 597.45 0 746.71 298.52 746.71 149.26 597.45"
          />
          <polyline
            fill={coloursRan.pop()}
            points="447.99 596.21 447.71 806.93 658.59 596.05 658.48 386.05"
          />
          <polygon
            fill={tipsRan.pop()}
            points="658.42 385.74 658.42 807.9 1080.59 385.74 658.42 385.74"
          />
        </motion.svg>
      </Wrapper>
    );
  }
};

const ButterflyIcon = React.memo(Butterfly);

export { ButterflyIcon };

export interface Props {
  animate?: boolean;
  altText?: string;
  width?: string;
}
